module.exports = __webpack_public_path__ + "img/vehicleMetroWhite.660b0a2b.svg";